import { CombineProperties } from './combine-properties.model';
import { IncludeProperties } from './include-properties.model';

export class AdvanceSearchFilter {
    searchText: string;
    includeProperties: IncludeProperties;
    combineProperties: CombineProperties;
}
